import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhoIsThisFor() {
  const forYou = ['Sos mamá o papá y te sentís impotente al verlo sufrir.', 'Tu hijo la pasa mal en el recreo o a la salida del colegio.', "El colegio minimiza la situación diciendo 'son cosas de chicos'.", 'Querés darle herramientas prácticas que pueda usar hoy mismo.'];
  const notForYou = ['Hay violencia física grave que requiere intervención policial.', 'Buscás venganza o que tu hijo aprenda a pelear a los golpes.', 'Es una situación que ya está judicializada.', 'No estás dispuesto a dedicarle 15 minutos al día para practicar.'];
  return <section className="w-full py-20 px-6 bg-white pt-[70px] pb-[70px]" data-id="element-158">
      <div className="max-w-5xl mx-auto" data-id="element-159">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8" data-id="element-160">
          {/* Para vos si */}
          <FadeIn direction="right" data-id="element-161">
            <div className="bg-creme rounded-3xl p-8 md:p-10 border border-beige" data-id="element-162">
              <h3 className="font-playfair text-2xl md:text-3xl font-semibold text-dark-coffee mb-8 flex items-center gap-3" data-id="element-163">
                Para vos si...
              </h3>
              <ul className="space-y-6" data-id="element-164">
                {forYou.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-165">
                    <CheckCircle2 className="w-6 h-6 text-warm-accent shrink-0 mt-0.5" data-id="element-166" />
                    <span className="text-soft-brown leading-relaxed" data-id="element-167">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* No es para vos si */}
          <FadeIn direction="left" delay={0.2} data-id="element-168">
            <div className="bg-gray-50 rounded-3xl p-8 md:p-10 border border-gray-100" data-id="element-169">
              <h3 className="font-playfair text-2xl md:text-3xl font-semibold text-gray-400 mb-8 flex items-center gap-3" data-id="element-170">
                No es para vos si...
              </h3>
              <ul className="space-y-6" data-id="element-171">
                {notForYou.map((item, index) => <li key={index} className="flex items-start gap-4 opacity-70" data-id="element-172">
                    <XCircle className="w-6 h-6 text-gray-400 shrink-0 mt-0.5" data-id="element-173" />
                    <span className="text-gray-500 leading-relaxed" data-id="element-174">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}